import { useEffect, useRef } from 'react';

export const useSafeTimeout = () => {
  const timeoutsRef = useRef<number[]>([]);

  const safeTimeout = (
    handler: (...params: any[]) => any,
    timeout?: number,
    ...args: any[]
  ) => {
    const timeoutID = window.setTimeout(handler, timeout, ...args);

    timeoutsRef.current = [...timeoutsRef.current, timeoutID];
  };

  useEffect(() => {
    return () => {
      timeoutsRef.current.forEach(timeout => {
        window.clearTimeout(timeout);
      });
    };
  }, []);

  return { safeTimeout };
};
